module.exports = __webpack_public_path__ + "media/images/crm/shape-square-main-yellow-c3ed65c8d2761703acae340e68e49dca.png";